import { render, staticRenderFns } from "./EditGame.vue?vue&type=template&id=21b02376&scoped=true"
import script from "./EditGame.vue?vue&type=script&lang=js"
export * from "./EditGame.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21b02376",
  null
  
)

export default component.exports